import { Component, OnInit, ViewChild } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

@Component({
  selector: 'app-job-image-template',
  templateUrl: './job-image-template.component.html',
  styleUrls: ['./job-image-template.component.scss']
})
export class JobImageTemplateComponent implements OnInit {
  constructor(private jobService: JobService, private spinner: SpinnerService) { }
  Object = Object;

  templates: any[];
  selected: any = {};

  @ViewChild('templateModal') templateModal: NgxSmartModalComponent;
  async ngOnInit() {
    await this.load();
  }

  private async load() {
    this.spinner.show();
    this.templates = await this.jobService.templates();
    this.spinner.hide();
  }

  openModal(template?: any) {
    this.selected = Object.assign({}, template || { Width: 1024 });
    this.templateModal.open();
  }

  async delete(id: string) {
    this.spinner.show('action');
    await this.jobService.deleteTemplate(id);
    this.spinner.hide('action');
    await this.load();
  }

  async save() {
    this.spinner.show('action');
    await this.jobService.saveTemplate(this.selected);
    this.spinner.hide('action');
    this.templateModal.close();
    await this.load();
  }
}
